import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-documento-cargado',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './documento-cargado.component.html',
  styleUrl: './documento-cargado.component.css',
})
export class DocumentoCargadoComponent implements OnInit {
  documentoForm!: FormGroup;
  id_documento_cargado!: number;
  id_documento: string | null = null;
  historialAdmin: any[] = [];
  historialInstitucion: any[] = [];
  currentEstado: string = '';
  // Lista de estados que se pueden seleccionar en el desplegable
  estadosCambio: string[] = ['LOGRADO', 'OBSERVADO', 'PROCESO'];
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.documentoForm = this.fb.group({
      nombre: [{ value: '', disabled: true }],
      estado_actual: [{ value: '', disabled: true }],
      estado: [{ value: '', disabled: false }], // Se habilita para cambiar el estado
      fecha_subida: [{ value: '', disabled: true }],
      link_archivo: [{ value: '', disabled: true }],
      institucion: [{ value: '', disabled: true }],
      director: [{ value: '', disabled: true }],
    });

    this.route.queryParams.subscribe((params) => {
      this.id_documento = params['id_documento'] || null;
      this.id_documento_cargado = params['id_documento_cargado'];
    });

    if (!this.id_documento_cargado) {
      Swal.fire('Error', 'Documento no válido.', 'error').then(() => {
        this.router.navigate(['/documentos']);
      });
      return;
    }

    this.cargarDocumento();
    this.cargarHistorialAdmin();
    this.cargarHistorialInstitucion();
  }

  cargarDocumento(): void {
    this.http
      .get(
        environment.apiUrl + `/documento-cargado/${this.id_documento_cargado}`
      )
      .subscribe((response: any) => {
        if (response) {
          //console.log(response.fecha_subida);
          this.documentoForm.patchValue({
            nombre: response.nombre || '',
            estado_actual: response.estado || '',
            fecha_subida: response.fecha_subida
              ? this.formatearFecha(response.fecha_subida)
              : '',
            link_archivo: response.link_archivo || '',
            institucion:
              response.institucionEducativa?.cen_edu || 'No disponible',
            director:
              response.institucionEducativa?.director || 'No disponible',
          });
          this.currentEstado = response.estado;
          // Actualizar los estados disponibles según el estado actual
          this.actualizarEstadosDisponibles();
          // Bloquear el desplegable si el estado actual es 'APROBADO'
          if (this.currentEstado === 'LOGRADO') {
            this.documentoForm.get('estado')?.disable();
          }
        }
      });
  }

  cargarHistorialAdmin(): void {
    this.http
      .get(
        environment.apiUrl +
          `/historial-admin?id_documento_cargado=${this.id_documento_cargado}`
      )
      .subscribe((response: any) => {
        if (Array.isArray(response)) {
          this.historialAdmin = response.map((item) => ({
            accion: item.accion || '',
            fecha: item.fecha || '',
            observacion: item.observacion || '',
            usuarioNombreCompleto: `${item.rolUsuario.usuario?.nombres || ''} ${
              item.rolUsuario.usuario?.apellidos || ''
            }`.trim(),
          }));
        } else {
          this.historialAdmin = [];
        }
      });
  }

  cargarHistorialInstitucion(): void {
    this.http
      .get(
        environment.apiUrl +
          `/historial-institucion?id_documento_cargado=${this.id_documento_cargado}`
      )
      .subscribe((response: any) => {
        if (Array.isArray(response)) {
          this.historialInstitucion = response.map((item) => ({
            accion: item.accion || '',
            fecha: item.fecha || '',
            link_archivo: item.link_archivo || '',
          }));
        } else {
          this.historialInstitucion = [];
        }
      });
  }

  onEstadoChange(event: any): void {
    const selectedEstado = event.target.value;
    // console.log('Estado seleccionado:', selectedEstado);
    // console.log('Estado actual:', this.currentEstado);
    if (this.currentEstado !== selectedEstado) {
      Swal.fire({
        title: '¿Actualizar estado?',
        input: 'textarea',
        inputLabel: 'Observación',
        inputPlaceholder: 'Ingrese la observación',

        showCancelButton: true,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        // console.log(result);
        if (result.isConfirmed) {
          this.actualizarEstado(selectedEstado, result.value?.trim() || '');
        }
      });
    }
  }
  actualizarEstadosDisponibles(): void {
    const transicionesPermitidas: { [key: string]: string[] } = {
      INICIADO: ['LOGRADO', 'OBSERVADO', 'PROCESO'],
      PROCESO: ['LOGRADO', 'OBSERVADO'],
      OBSERVADO: [], // No se permite cambiar desde OBSERVADO
      RECTIFICADO: ['LOGRADO', 'OBSERVADO', 'PROCESO'],
      LOGRADO: [], // No se permite cambiar desde LOGRADO
    };

    // Actualizar la lista de estados disponibles
    this.estadosCambio = transicionesPermitidas[this.currentEstado] || [];
  }

  actualizarEstado(estado: string, observacion: string): void {
    const id_rol_usuario = JSON.parse(
      localStorage.getItem('user') || '{}'
    ).id_rol_usuario;

    const body = {
      accion: estado,
      observacion: observacion,
      id_documento_cargado: this.id_documento_cargado,
      id_rol_usuario: id_rol_usuario,
    };

    this.http.post(environment.apiUrl + '/historial-admin', body).subscribe(
      (response) => {
        // Recargar el historial admin
        this.cargarHistorialAdmin();
        this.actualizarEstadoDocumentoCargado(estado);
        // location.reload(); // Recargar la página
      },
      (error) => {
        // Este bloque maneja cualquier error no capturado por catchError
        //console.error(error);
        Swal.fire(
          'Error',
          error.error.message || 'No se pudo procesar la solicitud.',
          'error'
        );
      }
    );
  }

  actualizarEstadoDocumentoCargado(estado: string): void {
    const id_rol_usuario = JSON.parse(
      localStorage.getItem('user') || '{}'
    ).id_rol_usuario;

    const body = {
      estado: estado,
    };
    this.http
      .patch(
        environment.apiUrl + `/documento-cargado/${this.id_documento_cargado}`,
        body
      )
      .subscribe(
        (response) => {
          // Actualizar el estado actual y la lista de estados disponibles
          this.currentEstado = estado;
          this.actualizarEstadosDisponibles();
          Swal.fire('Éxito', 'Estado actualizado con éxito.', 'success').then(
            () => {
              // this.currentEstado = estado;
              // this.actualizarEstadosDisponibles();
              // location.reload(); // Recargar la página
              this.cargarHistorialAdmin();
            }
          );
        },
        (error) => {
          //console.error('Error al actualizar el estado:', error);
          Swal.fire(
            'Error',
            error.error.message || 'No se pudo actualizar el estado.',
            'error'
          );
        }
      );
  }

  formatearFecha(fechaISO: string): string {
    const fecha = new Date(fechaISO); // Convertir la cadena ISO a un objeto Date

    // Obtener día, mes, año, horas y minutos
    const dia = fecha.getDate().toString().padStart(2, '0'); // Día con 2 dígitos
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Mes con 2 dígitos
    const anio = fecha.getFullYear(); // Año con 4 dígitos
    const horas = fecha.getHours().toString().padStart(2, '0'); // Horas con 2 dígitos
    const minutos = fecha.getMinutes().toString().padStart(2, '0'); // Minutos con 2 dígitos

    // Formatear la fecha como "dd/MM/yyyy HH:mm"
    return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
  }

  volver(): void {
    this.router.navigate(['/documentos-cargados'], {
      queryParams: { id_documento: this.id_documento },
    });
  }
}
